import { render, staticRenderFns } from "./collapseItem.vue?vue&type=template&id=60cf87d4&scoped=true&"
import script from "./collapseItem.vue?vue&type=script&lang=js&"
export * from "./collapseItem.vue?vue&type=script&lang=js&"
import style0 from "./collapseItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./collapseItem.vue?vue&type=style&index=1&id=60cf87d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf87d4",
  null
  
)

export default component.exports